/*Status Version Api By Url Site*/
/*const VERSION_STATUS: boolean = window.location.hostname.search('react.fruitmruit.com') !== -1;*/
const VERSION_STATUS: boolean = window.location.hostname === 'fruitmruit.com' || window.location.hostname === 'www.fruitmruit.com';

/*Selected Version Api*/
const VERSION_API: string = VERSION_STATUS ? 'v2' : 'beta';
/*Selected Version Image*/
const VERSION_IMG: string = VERSION_STATUS ? '' : 'beta.';

export const BASE_URL: string = `https://api.fruitmruit.com/${VERSION_API}/`;

export const LOGIN_OR_REGISTER_POST: string = 'users/login_or_register'; //mobile
export const RESEND_ACTIVATION_COD_POST: string = 'users/resend_activation_code'; //mobile
export const USERS_ACTIVATION_POST: string = 'users/activation'; //code
export const USERS_LOGOUT_GET: string = 'users/logout'; //Authorization
export const USERS_CHECK_LOGIN_POST: string = 'users/check_login'; //Authorization
export const USERS_PROFILE_GET: string = 'users/profile'; //Authorization
export const USERS_EDIT_PROFILE: string = 'users/edit_profile'; //fullName ,email ,Authorization,address_title,glat,glng
export const STORES_GET: string = 'stores'; //glat,glng,Authorization
export const MAIN_POST: string = 'main'; //store,platform
export const MORE_PRODUCTS_ALL_POST: string = 'products/all'; //category
export const MORE_PRODUCTS_DETAILS_POST: string = 'products/details'; //category
export const PAYMENT_CHARGE_WALLET: string = 'payment/charge_wallet';
export const USERS_TRANSACTIONS_POST: string = 'users/transactions';//offset
export const USERS_CARROT_TRANSACTIONS_POST: string = 'users/carrot_transactions';//offset
export const ORDERS_BASKET_POST: string = 'orders/basket';//basket_products
export const USERS_ADDRESS_GET: string = 'users/get_address';//Authorization
export const AREAS_VALIDATE_POINT_POST: string = 'areas/validate_points';//glat,glng
export const USERS_ADD_ADDRESS: string = 'users/add_address';//address,glat,glng
export const DELIVERIES_GET_DAY_TIMES_POST: string = 'deliveries/get_day_times';//basket_products,addressId
export const QUESTIONS_POST: string = 'questions';//store,Auth,...
export const FACTORS_PRE_POST: string = 'factors/pre';//store,Auth,...
export const ORDERS_REGISTER_POST: string = 'orders/register';//store,Auth,...
export const ORDERS_EDIT_POST: string = 'orders/edit';//store,Auth,...
export const PRODUCTS_SEARCH_POST: string = 'products/search';//store,search_text
export const PRODUCTS_SEARCH_RESULT_POST: string = 'products/search_result';//store,search_text
export const USERS_ORDERS_HISTORY_POST: string = 'users/orders_history';//offset
export const USERS_COMPLETE_REGISTRATION: string = 'users/complete_registration';//fullName,address_title,glat,glng
export const CONTACT_US: string = 'contact_us';//Authorization,mobile,name,comment,subject
export const COMPLAINT_POST: string = 'complaint';//comment
export const USERS_DELETE_ADDRESS_POST: string = 'users/delete_address';//Authorization,address_num
export const USERS_EDIT_ADDRESS_POST: string = 'users/edit_address';//Authorization,address_num,address,glng,glat
export const POLLS_REGISTER_POST: string = 'polls/register';//Authorization,order,rate,comment
export const ORDERS_DETAILS_POST: string = 'orders/details';//Authorization,order
export const ORDER_CANCEL_POST: string = 'orders/cancel';//Authorization,order
export const ORDER_CHANGE_ADDRESS: string = 'orders/change_address';//Authorization,order,address
export const ORDER_CHANGE_DELIVERY_TIME: string = 'orders/change_delivery_datetime';//Authorization,order,time
export const URL_ORDER_GET_QUS_GRATUITY: string = 'questions/order_qus_info'; // Authorization,order
export const ORDER_GET_DELIVERY_TIMES_FOR_EDIT: string = 'deliveries/get_day_times_for_edit_order'; // Authorization,order
export const URL_ORDER_EDIT_DESC_GRATUITY: string = 'orders/change_desc_gratuity'; // Authorization,order,description,gratuity
export const DISCOUNT_CODE_POST: string = 'discount_codes';//Authorization,code

export const MY_DISCOUNTS_GET : string = 'discount_codes/my_codes';
export const MY_SHOW_DISCOUNTS_GET : string = 'discount_codes/selectable_codes';

export const INVITATION_LINK_GET : string = 'users/get_invitation_link';
export const FOOD_PACKAGE_POST : string = 'food_package/details';
export const MY_FOOD_PACKAGE_GET : string = 'food_package/my_pack';

export const EXCHANGE_CARROT: string = 'users/exchange_carrot';


/*Price Basket Shop*/
/*Example :
* payment/pay?order=ORDER_NUM&amount=AMOUNT&token=YOUR_TOKEN
* */
export const PAYMENT_PAY: string = "payment/pay";
export const PAYMENT_EDIT_ORDER_PAY: string = "payment/edit_order_pay";

/*API GOOGLE MAP*/
export const BAE_API_GOOGLE_MAP: string = 'https://maps.googleapis.com/maps/api/';
export const GEOCODE_GOOGLE_MAP: string = 'geocode/json?latlng=';
export const KEY_GOOGLE_MAP: string = `&key=AIzaSyC5EiHaowyhg3Z3BU9L2aaZi98ZpNyVpmo`;
export const LANGUAGE_GOOGLE_MAP: string = '&language=fa';
export const GOOGLE_GET_GEOLOCATION: string = 'https://www.googleapis.com/geolocation/v1/geolocate?' + KEY_GOOGLE_MAP;//key

/*PUBLIC_URL_SITE*/
export const PUBLIC_URL_SERVER: string = `https://${VERSION_IMG}fruitmruit.com/`;
export const ICONS_PUBLIC_URL_SERVER: string = 'images/icons/';
export const IMG_DISCOUNT_PUBLIC_URL_SERVER: string = 'images/discount/480-129/';
export const IMG_PRODUCTS_PUBLIC_URL_SERVER: string = 'images/products/';
export const IMG_SLIDER_STORES_URL_SERVER: string = 'images/main_banners/';
export const IMG_SLIDER_FOOD_PACKAGE_URL_SERVER: string = 'images/food_packages/';

/*DOWNLOAD LINKS*/
export const ANDROID_APP_DOWNLOAD_URL: string = 'https://fruitmruit.com/files/FruitMruit_V32_R14010816_X12.apk';
export const ANDROID_APP_DOWNLOAD_BAAZAAR_URL: string = 'https://cafebazaar.ir/app/ir.ark.fruits';



/*SUPPOERT PHONE*/
export const FRUITMRUIT_SUPPORT_PHONE: string = '+989178788917';



/*SOCIAL LINKS*/
export const FRUITMRUIT_WHATSAPP_MOBILE: string = 'https://api.whatsapp.com/send?phone=' + FRUITMRUIT_SUPPORT_PHONE;
export const FRUITMRUIT_WHATSAPP_WEB: string = 'whatsapp://send?phone=' + FRUITMRUIT_SUPPORT_PHONE;
export const FRUITMRUIT_INSTAGRAM: string = 'https://www.instagram.com/fruitmruit/';


